var _radialGradient, _radialGradient2, _radialGradient3, _linearGradient, _linearGradient2, _path, _path2, _path3, _rect, _path4, _rect2, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgGraphicTwoFactorAuth = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "2in",
    viewBox: "0 0 216 144",
    width: "3in",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 217.53,
    cy: 149.82,
    gradientUnits: "userSpaceOnUse",
    r: 102.61
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#cdcdd4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#cdcdd4",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#cdcdd4",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#cdcdd4",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#cdcdd4",
    stopOpacity: 0.2
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: -31.59,
    cy: 147.37,
    gradientUnits: "userSpaceOnUse",
    r: 150.75
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#cdcdd4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#cdcdd4",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#cdcdd4",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#cdcdd4",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#cdcdd4",
    stopOpacity: 0.2
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 129.21,
    cy: 117.26,
    gradientTransform: "matrix(1 0 0 .7 0 35.37)",
    gradientUnits: "userSpaceOnUse",
    r: 112.67
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#cdcdd4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#cdcdd4",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#cdcdd4",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#cdcdd4",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cdcdd4",
    stopOpacity: 0.2
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 36.89,
    x2: 185.47,
    y1: 153.32,
    y2: -16.58
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#b833e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#ff4f5e"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 66.71,
    x2: 151.25,
    y1: 101.3,
    y2: 16.76
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#7542e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#824deb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#a067fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ab71ff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m202.85 91.19a9.51 9.51 0 0 1 -9.47 9.51h-38.07a7.27 7.27 0 0 1 0-14.54 7.09 7.09 0 0 1 1.74.22 7.89 7.89 0 0 1 -.19-1.69 7.49 7.49 0 0 1 7.5-7.49 7.41 7.41 0 0 1 4.23 1.31 12.6 12.6 0 0 1 24.79 3.17 9.5 9.5 0 0 1 9.47 9.51z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m86.23 49.32a10.8 10.8 0 0 0 -2.62.32 11.15 11.15 0 0 0 .29-2.53 11.31 11.31 0 0 0 -17.69-9.32 19 19 0 0 0 -37.36 4.78 14.27 14.27 0 1 0 0 28.53h57.38a10.89 10.89 0 1 0 0-21.78z",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m24.87 72.66a22.54 22.54 0 0 1 22.45-22.66l120.77-.48a22.53 22.53 0 1 1 .18 45.06l-120.77.53a22.54 22.54 0 0 1 -22.63-22.45z",
    fill: "url(#c)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "url(#d)",
    height: 99.33,
    rx: 5.4,
    width: 61.42,
    x: 77.29,
    y: 22.33
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m113.2 115.07h-10.4v-4.4h10.4z",
    fill: "#ff848b"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "url(#e)",
    height: 18.34,
    rx: 7.2,
    width: 102.11,
    x: 56.94,
    y: 50.84
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m83.31 59a.33.33 0 0 0 0-.29l-.75-1.32a.33.33 0 0 0 -.23-.17.37.37 0 0 0 -.29.06l-1.74 1.26.26-2.14a.32.32 0 0 0 -.08-.28.4.4 0 0 0 -.27-.12h-1.52a.38.38 0 0 0 -.27.12.37.37 0 0 0 -.09.28l.27 2.14-1.72-1.31a.35.35 0 0 0 -.28-.06.37.37 0 0 0 -.24.16l-.77 1.3a.37.37 0 0 0 0 .29.36.36 0 0 0 .2.22l2 .86-2 .84a.38.38 0 0 0 -.2.21.37.37 0 0 0 0 .29l.74 1.32a.35.35 0 0 0 .24.17.37.37 0 0 0 .29-.06l1.74-1.31-.27 2.16a.37.37 0 0 0 .09.28.38.38 0 0 0 .27.12h1.52a.4.4 0 0 0 .27-.12.32.32 0 0 0 .08-.28l-.26-2.15 1.7 1.3a.38.38 0 0 0 .29.06.34.34 0 0 0 .24-.16l.78-1.32a.35.35 0 0 0 0-.3.34.34 0 0 0 -.2-.21l-2-.83 2-.83a.32.32 0 0 0 .2-.18zm11.43 0a.37.37 0 0 0 0-.29l-.74-1.35a.35.35 0 0 0 -.24-.17.38.38 0 0 0 -.29.06l-1.72 1.29.25-2.14a.37.37 0 0 0 -.09-.28.36.36 0 0 0 -.26-.12h-1.54a.4.4 0 0 0 -.27.12.36.36 0 0 0 -.08.28l.24 2.14-1.7-1.31a.35.35 0 0 0 -.28-.06.37.37 0 0 0 -.24.16l-.78 1.3a.37.37 0 0 0 0 .29.35.35 0 0 0 .19.22l2 .86-2 .84a.32.32 0 0 0 -.2.21.37.37 0 0 0 0 .29l.74 1.32a.33.33 0 0 0 .24.17.35.35 0 0 0 .28-.06l1.75-1.31-.27 2.16a.36.36 0 0 0 .08.28.4.4 0 0 0 .27.12h1.53a.36.36 0 0 0 .26-.12.37.37 0 0 0 .09-.28l-.27-2.15 1.68 1.3a.35.35 0 0 0 .28.06.34.34 0 0 0 .24-.16l.79-1.32a.39.39 0 0 0 0-.3.37.37 0 0 0 -.2-.21l-2-.83 2-.83a.38.38 0 0 0 .26-.18zm11.42 0a.37.37 0 0 0 0-.29l-.74-1.32a.33.33 0 0 0 -.23-.17.37.37 0 0 0 -.29.06l-1.72 1.29.26-2.14a.32.32 0 0 0 -.08-.28.4.4 0 0 0 -.27-.12h-1.53a.37.37 0 0 0 -.26.12.37.37 0 0 0 -.09.28l.27 2.14-1.72-1.31a.37.37 0 0 0 -.29-.06.35.35 0 0 0 -.23.16l-.77 1.3a.37.37 0 0 0 0 .29.36.36 0 0 0 .2.22l2 .86-2 .84a.38.38 0 0 0 -.2.21.37.37 0 0 0 0 .29l.74 1.32a.35.35 0 0 0 .24.17.38.38 0 0 0 .29-.06l1.74-1.31-.27 2.16a.37.37 0 0 0 .09.28.37.37 0 0 0 .26.12h1.53a.4.4 0 0 0 .27-.12.32.32 0 0 0 .08-.28l-.26-2.15 1.67 1.3a.38.38 0 0 0 .29.06.34.34 0 0 0 .24-.16l.78-1.32a.39.39 0 0 0 0-.3.34.34 0 0 0 -.2-.21l-1.96-.87 2-.83a.32.32 0 0 0 .16-.17zm11.43 0a.37.37 0 0 0 0-.29l-.74-1.32a.35.35 0 0 0 -.24-.17.38.38 0 0 0 -.29.06l-1.72 1.29.27-2.14a.37.37 0 0 0 -.09-.28.37.37 0 0 0 -.26-.12h-1.52a.4.4 0 0 0 -.27.12.36.36 0 0 0 -.08.28l.26 2.14-1.72-1.31a.35.35 0 0 0 -.28-.06.37.37 0 0 0 -.24.16l-.76 1.3a.37.37 0 0 0 0 .29.35.35 0 0 0 .19.22l2 .86-2 .84a.32.32 0 0 0 -.2.21.37.37 0 0 0 0 .29l.74 1.32a.33.33 0 0 0 .23.17.36.36 0 0 0 .29-.06l1.74-1.31-.26 2.16a.36.36 0 0 0 .08.28.4.4 0 0 0 .28.07h1.53a.37.37 0 0 0 .26-.12.37.37 0 0 0 .09-.28l-.27-2.15 1.68 1.3a.35.35 0 0 0 .28.06.34.34 0 0 0 .24-.16l.79-1.32a.39.39 0 0 0 0-.3.41.41 0 0 0 -.2-.21l-2-.83 2-.83a.38.38 0 0 0 .19-.16zm11.41 0a.37.37 0 0 0 0-.29l-.74-1.32a.33.33 0 0 0 -.23-.17.37.37 0 0 0 -.29.06l-1.74 1.26.26-2.14a.36.36 0 0 0 -.08-.28.4.4 0 0 0 -.27-.12h-1.53a.36.36 0 0 0 -.26.12.37.37 0 0 0 -.09.28l.27 2.14-1.72-1.31a.37.37 0 0 0 -.29-.06.35.35 0 0 0 -.23.16l-.77 1.3a.37.37 0 0 0 0 .29.34.34 0 0 0 .2.22l2 .86-2 .84a.38.38 0 0 0 -.2.21.37.37 0 0 0 0 .29l.74 1.32a.35.35 0 0 0 .24.17.38.38 0 0 0 .29-.06l1.74-1.31-.3 2.16a.37.37 0 0 0 .09.28.36.36 0 0 0 .26.12h1.53a.4.4 0 0 0 .27-.12.36.36 0 0 0 .08-.28l-.23-2.15 1.67 1.3a.37.37 0 0 0 .29.06.36.36 0 0 0 .24-.16l.78-1.32a.39.39 0 0 0 0-.3.34.34 0 0 0 -.2-.21l-2-.83 2-.83a.35.35 0 0 0 .22-.18zm11.44 0a.37.37 0 0 0 0-.29l-.74-1.32a.35.35 0 0 0 -.24-.17.37.37 0 0 0 -.29.06l-1.72 1.29.27-2.14a.37.37 0 0 0 -.09-.28.38.38 0 0 0 -.27-.12h-1.52a.4.4 0 0 0 -.27.12.32.32 0 0 0 -.08.28l.26 2.14-1.75-1.34a.35.35 0 0 0 -.28-.06.37.37 0 0 0 -.24.16l-.76 1.3a.33.33 0 0 0 0 .29.35.35 0 0 0 .19.22l2 .86-2 .84a.32.32 0 0 0 -.2.21.33.33 0 0 0 0 .29l.75 1.32a.33.33 0 0 0 .23.17.37.37 0 0 0 .29-.06l1.74-1.31-.26 2.16a.32.32 0 0 0 .08.28.4.4 0 0 0 .27.12h1.52a.38.38 0 0 0 .27-.12.37.37 0 0 0 .09-.28l-.27-2.15 1.68 1.3a.35.35 0 0 0 .28.06.34.34 0 0 0 .24-.16l.78-1.32a.35.35 0 0 0 0-.3.41.41 0 0 0 -.2-.21l-2-.83 2-.83a.38.38 0 0 0 .24-.18z",
    fill: "#f9f9fa"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGraphicTwoFactorAuth);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/graphic_two_factor_auth.f58572c57e0fd169c59f7cac8578730f.svg";